/*
 * @Author: csu chen.su@murata.com
 * @Date: 2022-06-22 15:36:49
 * @LastEditors: csu chen.su@murata.com
 * @LastEditTime: 2024-01-16 09:59:41
 * @FilePath: \frontend\src\main.js
 */
import { createApp } from 'vue';
// import promise from 'es6-promise';
import ElementPlus from 'element-plus';
// import UmyUi from 'umy-ui';

// import 'babel-polyfill';
import 'normalize.css/normalize.css'; // A modern alternative to CSS resets
import 'element-plus/theme-chalk/index.css';
import './assets/icon/iconfont.css';
import '@/styles/index.scss'; // global css
// import 'umy-ui/lib/theme-chalk/index.css';
import '@/styles/amplify_globals.css'; // amplify global css
import '@aws-amplify/ui-vue/styles.css';

import App from './App.vue';
import store from './store';
import router from './router';
import { b64toBlob } from '@/utils/index';
import { i18n, langSetup } from '@/Lang/index';
import SvgIcon from '@/components/SvgIcon/index.vue'; // svg component

// import '@/icons'; // icon
import '@/permission'; // permission control

import { Amplify } from 'aws-amplify';
import { awsconfig } from './aws-exports';

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */

function checkFull() {
  var isFull =
    document.fullscreenEnabled || window.fullScreen || document.webkitIsFullScreen || document.msFullscreenEnabled;
  // to fix : false || undefined == undefined
  if (isFull === undefined) {
    isFull = false;
  }
  return isFull;
}

const app = createApp(App);

// set ElementUI lang to EN
app.use(ElementPlus, {
  i18n: (key, value) => i18n.global.t(key, value),
});
// 如果想要中文版 element-ui，按如下方式声明
// app.use(UmyUi);
// promise.polyfill();

// global method
app.config.globalProperties.checkFull = checkFull;
app.config.globalProperties.b64toBlob = b64toBlob;
app.config.globalProperties.notify = App.methods.notify;
app.config.globalProperties.message = App.methods.message;
app.langSetup = app.config.globalProperties.$langSetup = langSetup;

// icons
app.component('SvgIcon', SvgIcon);
import.meta.glob('./icons/svg/**/*.svg', { eager: true });

// Configure Amplify
Amplify.configure(awsconfig[import.meta.env.MODE]);

app.use(i18n);
app.use(router);
app.use(store);

router.isReady().then(() => app.mount('#app'));
